import { parse as parseUrl } from 'url';

export function validateCianDomain(url: string) {
  const parsedUrl = parseUrl(url);
  const hostname = parsedUrl.hostname || '';

  return hostname.endsWith('.cian.ru');
}
